import { generateImage } from './generateImage';

export const actions = {
  generateImage,
};
